import angular from "angular";
import Assert from "tbAssert";

import ngResource from "angular-resource";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

import OfficeFactoryModule from "../models/factories/OfficeFactory";

function OfficeDataServiceFactory($resource, OfficeFactory, TbAppConfigDataService) {

    Assert.StrictAssert(OfficeFactory != null, "Assertion Failure: Missing Office Factory Service Dependency");
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const tbOfficeDataApiUrl = tbServerBaseUrl + "/api/offices/:officeId";
    const tbOfficeDetailsDataApiUrl = tbServerBaseUrl + "/api/offices/:officeId/details";
    const tbOfficeDataApiParams = { officeId: "@officeId" };

    const tbOfficeSubscribersApiUrl = tbServerBaseUrl + "/api/offices/:officeId/subscribers/:recipientId";
    const tbOfficeSubscribersApiParams = { officeId: "@officeId", recipientId: "@recipientId" };

    const officeDataResponseInterceptor = (serverResponse) => {
        let serverOfficeObj = OfficeFactory.FromServerOffice(serverResponse.data);

        angular.extend(serverResponse.resource, {
            result: serverOfficeObj
        });

        return serverResponse.resource;
    };

    return $resource(
        tbOfficeDetailsDataApiUrl,
        tbOfficeDataApiParams,
        {
            get: {
                method: "GET",
                url: tbOfficeDetailsDataApiUrl,
                params: tbOfficeDataApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeDataResponseInterceptor
                }
            },
            getCore: {
                method: "GET",
                url: tbOfficeDataApiUrl,
                params: tbOfficeDataApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeDataResponseInterceptor
                }
            },
            addSubscription: {
                method: "PUT",
                url: tbOfficeSubscribersApiUrl,
                params: tbOfficeSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeDataResponseInterceptor
                }
            },
            removeSubscription: {
                method: "DELETE",
                url: tbOfficeSubscribersApiUrl,
                params: tbOfficeSubscribersApiParams,
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: officeDataResponseInterceptor
                }
            }
        }
    );
}

OfficeDataServiceFactory.$inject = [ "$resource", "OfficeFactory", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.office-data-service",[
        ngResource,
        OfficeFactoryModule,
        TbAppConfigDataServiceModule
    ])
    .factory("OfficeData", OfficeDataServiceFactory)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/OfficeDataService.js
// module id = tgT/
// module chunks = 1